import React from 'react';
import {
  FlowAction,
  type FlowData___PrimitiveInputFragment,
  type FlowData___PrimitiveListInputFragment,
} from '~/graphql/types';
import ConditionEditor from '../ConditionEditorV2';
import { Props as FormProps } from '../ActionForm';
import { ClientFlowActionIfElse } from '~/graphql/types.client';
import { Body } from '~/components/atom/Typography';
import TrueOrFalseLabel from '../../../Builder/components/TrueOrFalseLabel';
import type { RelativeMaps } from '~/components/page/Automation/v2/types';

export type Props = FormProps & {
  dataTestId?: string;
  action: ClientFlowActionIfElse;
  maps: RelativeMaps;
  inputPrimitives: Array<FlowData___PrimitiveInputFragment>;
  inputListPrimitives: Array<FlowData___PrimitiveListInputFragment>;
};

const IfElseAction: React.FCC<Props> = ({
  action,
  maps,
  inputListPrimitives,
  inputPrimitives,
  onChange,
}) => (
  <div>
    <Body margin={[null, null, 'm', null]}>
      Voeg één of meer condities toe, waarop de flow controleert. Op basis van
      deze condities gaat de flow verder in&nbsp;
      <TrueOrFalseLabel type="true" />
      &nbsp;of&nbsp;
      <TrueOrFalseLabel type="false" />.
    </Body>
    <ConditionEditor
      actionId={action.id}
      action={FlowAction.IfElse}
      hasTriggers={false}
      conditionExpression={action.condition}
      textObject={{
        newCondition: '',
        emptyCondition: 'Selecteer een conditie...',
        newTrigger: 'Voeg een conditie toe',
        emptyTrigger: 'Selecteer een conditie...',
        addValue: '+ Waarde toevoegen',
      }}
      maps={maps}
      inputListPrimitives={inputListPrimitives}
      inputPrimitives={inputPrimitives}
      onChange={nextConditionExpression =>
        onChange({
          ...action,
          condition: nextConditionExpression,
        })
      }
    />
  </div>
);

export default IfElseAction;
